export default __webpack_public_path__ + "media/avatars/12-9a639271.png";